module.exports = __webpack_public_path__ + "static/media/red-ai.a1e4990c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/red-ai.jpg
// module id = 38
// module chunks = 0